import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { PipelineContext34fsb0mycu471 as PipelineContext } from '../../../../../ktor-ktor-utils/io/ktor/util/pipeline/PipelineContext.mjs';
import { Phases_getInstance1n7sbxr3lcpvf as Phases_getInstance } from '../request/HttpRequestPipeline.mjs';
import {
  isSuspendFunction153vlp5l2npj9 as isSuspendFunction,
  isInterface3d6p8outrmvmk as isInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  HttpResponseContainer3r9yzy4mwwvc9 as HttpResponseContainer,
  Phases_getInstance1ydmp5ct4mzr8 as Phases_getInstance_0,
} from '../statement/HttpResponsePipeline.mjs';
import { PipelinePhase2q3d54imxjlma as PipelinePhase } from '../../../../../ktor-ktor-utils/io/ktor/util/pipeline/PipelinePhase.mjs';
import { reversed22y3au42jl32b as reversed } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  SetupRequest_instance2wgomqglvou5t as SetupRequest_instance,
  Send_instance2se4t9sd7p3bp as Send_instance,
  Sender1wtdgti85uk42 as Sender,
} from './api/CommonHooks.mjs';
import {
  HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder,
  HttpRequest3fsc4149kgwfg as HttpRequest,
  get_coroutineContext1djaai1ellg0c as get_coroutineContext,
} from '../request/HttpRequest.mjs';
import { unwrapCancellationException1zvbmufui4i9c as unwrapCancellationException } from '../utils/ExceptionUtils.nonJvm.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { OutgoingContent3t2ohmyam9o76 as OutgoingContent } from '../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
import { createClientPluginjwpvufjows5r as createClientPlugin } from './api/CreatePluginUtils.mjs';
import { PrimitiveClasses_getInstanceds06xwqrwfdm as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_LOGGER() {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  return LOGGER;
}
var LOGGER;
function get_HttpCallValidator() {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  return HttpCallValidator;
}
var HttpCallValidator;
function get_ExpectSuccessAttributeKey() {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  return ExpectSuccessAttributeKey;
}
var ExpectSuccessAttributeKey;
var HttpCallValidatorConfigClass;
function HttpCallValidatorConfig() {
  if (HttpCallValidatorConfigClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.c5o_1 = ArrayList().p2();
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_0.d5o_1 = ArrayList().p2();
        this.e5o_1 = true;
      }
      f5o(block) {
        // Inline function 'kotlin.collections.plusAssign' call
        this.c5o_1.i2(block);
      }
    }
    initMetadataForClass($, 'HttpCallValidatorConfig', HttpCallValidatorConfig);
    HttpCallValidatorConfigClass = $;
  }
  return HttpCallValidatorConfigClass;
}
function HttpResponseValidator(_this__u8e3s4, block) {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  _this__u8e3s4.p5i(get_HttpCallValidator(), block);
}
var ExceptionHandlerWrapperClass;
function ExceptionHandlerWrapper() {
  if (ExceptionHandlerWrapperClass === VOID) {
    class $ {}
    initMetadataForClass($, 'ExceptionHandlerWrapper');
    ExceptionHandlerWrapperClass = $;
  }
  return ExceptionHandlerWrapperClass;
}
var RequestExceptionHandlerWrapperClass;
function RequestExceptionHandlerWrapper() {
  if (RequestExceptionHandlerWrapperClass === VOID) {
    class $ {}
    initMetadataForClass($, 'RequestExceptionHandlerWrapper');
    RequestExceptionHandlerWrapperClass = $;
  }
  return RequestExceptionHandlerWrapperClass;
}
var RequestError$install$slambdaClass;
function RequestError$install$slambda() {
  if (RequestError$install$slambdaClass === VOID) {
    class $ {
      constructor($handler) {
        this.w5p_1 = $handler;
      }
      *i5g($this$intercept, it, $completion) {
        try {
          yield* $this$intercept.a4r($completion);
        } catch ($p) {
          if ($p instanceof Error) {
            var cause = $p;
            var error = yield* this.w5p_1(HttpRequest_0($this$intercept.x4r_1), cause, $completion);
            if (!(error == null))
              throw error;
          } else {
            throw $p;
          }
        }
        return Unit_instance;
      }
      md(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.i5g(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    RequestError$install$slambdaClass = $;
  }
  return RequestError$install$slambdaClass;
}
function RequestError$install$slambda_0($handler) {
  var i = new (RequestError$install$slambda())($handler);
  var l = ($this$intercept, it, $completion) => i.i5g($this$intercept, it, $completion);
  l.$arity = 2;
  return l;
}
var RequestErrorClass;
function RequestError() {
  if (RequestErrorClass === VOID) {
    class $ {
      x5p(client, handler) {
        var tmp = Phases_getInstance().z5m_1;
        client.p5g_1.b4s(tmp, RequestError$install$slambda_0(handler));
      }
      e5n(client, handler) {
        return this.x5p(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'RequestError');
    RequestErrorClass = $;
  }
  return RequestErrorClass;
}
var RequestError_instance;
function RequestError_getInstance() {
  return RequestError_instance;
}
var ReceiveError$install$slambdaClass;
function ReceiveError$install$slambda() {
  if (ReceiveError$install$slambdaClass === VOID) {
    class $ {
      constructor($handler) {
        this.y5p_1 = $handler;
      }
      *f5h($this$intercept, it, $completion) {
        try {
          yield* $this$intercept.a4r($completion);
        } catch ($p) {
          if ($p instanceof Error) {
            var cause = $p;
            var error = yield* this.y5p_1($this$intercept.x4r_1.x5i(), cause, $completion);
            if (!(error == null))
              throw error;
          } else {
            throw $p;
          }
        }
        return Unit_instance;
      }
      md(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.f5h(tmp, p2 instanceof HttpResponseContainer() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    ReceiveError$install$slambdaClass = $;
  }
  return ReceiveError$install$slambdaClass;
}
function ReceiveError$install$slambda_0($handler) {
  var i = new (ReceiveError$install$slambda())($handler);
  var l = ($this$intercept, it, $completion) => i.f5h($this$intercept, it, $completion);
  l.$arity = 2;
  return l;
}
var ReceiveErrorClass;
function ReceiveError() {
  if (ReceiveErrorClass === VOID) {
    class $ {
      x5p(client, handler) {
        var BeforeReceive = new (PipelinePhase())('BeforeReceive');
        client.q5g_1.a4s(Phases_getInstance_0().z5h_1, BeforeReceive);
        client.q5g_1.b4s(BeforeReceive, ReceiveError$install$slambda_0(handler));
      }
      e5n(client, handler) {
        return this.x5p(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'ReceiveError');
    ReceiveErrorClass = $;
  }
  return ReceiveErrorClass;
}
var ReceiveError_instance;
function ReceiveError_getInstance() {
  return ReceiveError_instance;
}
function HttpRequest_0(builder) {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  return new (HttpRequest$1())(builder);
}
function HttpCallValidatorConfig$_init_$ref_m1o2g9() {
  var l = () => new (HttpCallValidatorConfig())();
  l.callableName = '<init>';
  return l;
}
function HttpCallValidator$lambda($this$createClientPlugin) {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  var responseValidators = reversed($this$createClientPlugin.n5n_1.c5o_1);
  var callExceptionHandlers = reversed($this$createClientPlugin.n5n_1.d5o_1);
  var expectSuccess = $this$createClientPlugin.n5n_1.e5o_1;
  var tmp = SetupRequest_instance;
  $this$createClientPlugin.q5n(tmp, HttpCallValidator$lambda$slambda_0(expectSuccess));
  var tmp_0 = Send_instance;
  $this$createClientPlugin.q5n(tmp_0, HttpCallValidator$lambda$slambda_2(responseValidators));
  var tmp_1 = RequestError_instance;
  $this$createClientPlugin.q5n(tmp_1, HttpCallValidator$lambda$slambda_4(callExceptionHandlers));
  var tmp_2 = ReceiveError_instance;
  $this$createClientPlugin.q5n(tmp_2, HttpCallValidator$lambda$slambda_6(callExceptionHandlers));
  return Unit_instance;
}
function *invoke$validateResponse(responseValidators, response, $completion) {
  get_LOGGER().b4t('Validating response for request ' + response.e5j().x5i().g5j().toString());
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = responseValidators.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    yield* element(response, $completion);
  }
  return Unit_instance;
}
function *invoke$processException(callExceptionHandlers, cause, request, $completion) {
  get_LOGGER().b4t('Processing exception ' + cause.toString() + ' for request ' + request.g5j().toString());
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = callExceptionHandlers.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (element instanceof ExceptionHandlerWrapper())
      yield* element.a5q_1(cause, $completion);
    else {
      if (element instanceof RequestExceptionHandlerWrapper())
        yield* element.z5p_1(cause, request, $completion);
      else {
        noWhenBranchMatchedException();
      }
    }
  }
  return Unit_instance;
}
var HttpCallValidator$lambda$slambdaClass;
function HttpCallValidator$lambda$slambda() {
  if (HttpCallValidator$lambda$slambdaClass === VOID) {
    class $ {
      constructor($expectSuccess) {
        this.b5q_1 = $expectSuccess;
      }
      *c5q(request, $completion) {
        var tmp = get_ExpectSuccessAttributeKey();
        request.l5i_1.p4m(tmp, () => this.b5q_1);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.c5q(p1 instanceof HttpRequestBuilder() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    HttpCallValidator$lambda$slambdaClass = $;
  }
  return HttpCallValidator$lambda$slambdaClass;
}
function HttpCallValidator$lambda$slambda_0($expectSuccess) {
  var i = new (HttpCallValidator$lambda$slambda())($expectSuccess);
  var l = (request, $completion) => i.c5q(request, $completion);
  l.$arity = 1;
  return l;
}
var HttpCallValidator$lambda$slambdaClass_0;
function HttpCallValidator$lambda$slambda_1() {
  if (HttpCallValidator$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($responseValidators) {
        this.d5q_1 = $responseValidators;
      }
      *e5q($this$on, request, $completion) {
        var call = yield* $this$on.h5q(request, $completion);
        yield* /*#__NOINLINE__*/invoke$validateResponse(this.d5q_1, call.c5h(), $completion);
        return call;
      }
      md(p1, p2, $completion) {
        var tmp = p1 instanceof Sender() ? p1 : THROW_CCE();
        return this.e5q(tmp, p2 instanceof HttpRequestBuilder() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    HttpCallValidator$lambda$slambdaClass_0 = $;
  }
  return HttpCallValidator$lambda$slambdaClass_0;
}
function HttpCallValidator$lambda$slambda_2($responseValidators) {
  var i = new (HttpCallValidator$lambda$slambda_1())($responseValidators);
  var l = ($this$on, request, $completion) => i.e5q($this$on, request, $completion);
  l.$arity = 2;
  return l;
}
var HttpCallValidator$lambda$slambdaClass_1;
function HttpCallValidator$lambda$slambda_3() {
  if (HttpCallValidator$lambda$slambdaClass_1 === VOID) {
    class $ {
      constructor($callExceptionHandlers) {
        this.i5q_1 = $callExceptionHandlers;
      }
      *j5q(request, cause, $completion) {
        var unwrappedCause = unwrapCancellationException(cause);
        yield* /*#__NOINLINE__*/invoke$processException(this.i5q_1, unwrappedCause, request, $completion);
        return unwrappedCause;
      }
      md(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, HttpRequest()) : false) ? p1 : THROW_CCE();
        return this.j5q(tmp, p2 instanceof Error ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    HttpCallValidator$lambda$slambdaClass_1 = $;
  }
  return HttpCallValidator$lambda$slambdaClass_1;
}
function HttpCallValidator$lambda$slambda_4($callExceptionHandlers) {
  var i = new (HttpCallValidator$lambda$slambda_3())($callExceptionHandlers);
  var l = (request, cause, $completion) => i.j5q(request, cause, $completion);
  l.$arity = 2;
  return l;
}
var HttpCallValidator$lambda$slambdaClass_2;
function HttpCallValidator$lambda$slambda_5() {
  if (HttpCallValidator$lambda$slambdaClass_2 === VOID) {
    class $ {
      constructor($callExceptionHandlers) {
        this.k5q_1 = $callExceptionHandlers;
      }
      *j5q(request, cause, $completion) {
        var unwrappedCause = unwrapCancellationException(cause);
        yield* /*#__NOINLINE__*/invoke$processException(this.k5q_1, unwrappedCause, request, $completion);
        return unwrappedCause;
      }
      md(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, HttpRequest()) : false) ? p1 : THROW_CCE();
        return this.j5q(tmp, p2 instanceof Error ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    HttpCallValidator$lambda$slambdaClass_2 = $;
  }
  return HttpCallValidator$lambda$slambdaClass_2;
}
function HttpCallValidator$lambda$slambda_6($callExceptionHandlers) {
  var i = new (HttpCallValidator$lambda$slambda_5())($callExceptionHandlers);
  var l = (request, cause, $completion) => i.j5q(request, cause, $completion);
  l.$arity = 2;
  return l;
}
var HttpRequest$1Class;
function HttpRequest$1() {
  if (HttpRequest$1Class === VOID) {
    class $ {
      constructor($builder) {
        this.p5q_1 = $builder;
        this.l5q_1 = $builder.h5i_1;
        this.m5q_1 = $builder.g5i_1.y36();
        this.n5q_1 = $builder.l5i_1;
        this.o5q_1 = $builder.i5i_1.y36();
      }
      e5j() {
        // Inline function 'kotlin.error' call
        var message = 'Call is not initialized';
        throw IllegalStateException().o(toString(message));
      }
      f5j() {
        return this.l5q_1;
      }
      g5j() {
        return this.m5q_1;
      }
      y5i() {
        return this.n5q_1;
      }
      w50() {
        return this.o5q_1;
      }
      e2o() {
        var tmp = this.p5q_1.j5i_1;
        var tmp0_elvis_lhs = tmp instanceof OutgoingContent() ? tmp : null;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'Content was not transformed to OutgoingContent yet. Current body is ' + toString(this.p5q_1.j5i_1);
          throw IllegalStateException().o(toString(message));
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        return tmp_0;
      }
    }
    protoOf($).sv = get_coroutineContext;
    initMetadataForClass($, VOID, VOID, VOID, [HttpRequest()]);
    HttpRequest$1Class = $;
  }
  return HttpRequest$1Class;
}
var properties_initialized_HttpCallValidator_kt_xrx49w;
function _init_properties_HttpCallValidator_kt__r6yh2y() {
  if (!properties_initialized_HttpCallValidator_kt_xrx49w) {
    properties_initialized_HttpCallValidator_kt_xrx49w = true;
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.HttpCallValidator');
    var tmp = HttpCallValidatorConfig$_init_$ref_m1o2g9();
    HttpCallValidator = createClientPlugin('HttpResponseValidator', tmp, HttpCallValidator$lambda);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'ExpectSuccessAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_0 = PrimitiveClasses_getInstance().rf();
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_1;
    try {
      tmp_1 = createKType(PrimitiveClasses_getInstance().rf(), arrayOf([]), false);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_2 = null;
      } else {
        throw $p;
      }
      tmp_1 = tmp_2;
    }
    var tmp$ret$2 = tmp_1;
    var tmp$ret$1 = new (TypeInfo())(tmp_0, tmp$ret$2);
    ExpectSuccessAttributeKey = new (AttributeKey())(name, tmp$ret$1);
  }
}
//region block: init
RequestError_instance = new (RequestError())();
ReceiveError_instance = new (ReceiveError())();
//endregion
//region block: exports
export {
  get_ExpectSuccessAttributeKey as get_ExpectSuccessAttributeKey20jj5fup38v1g,
  get_HttpCallValidator as get_HttpCallValidator3iji36qylbtbr,
  HttpResponseValidator as HttpResponseValidator2d6ie1tmzg8fi,
};
//endregion

//# sourceMappingURL=HttpCallValidator.mjs.map
